import { render, staticRenderFns } from "./PersonalDataSection.html?vue&type=template&id=5a52a1e6&external"
import script from "./PersonalDataSection.ts?vue&type=script&lang=ts&external"
export * from "./PersonalDataSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports